import { SeatPickerScreenPosition } from '../types/config/screen-position';
import { SeatPickerShape } from '../types/config/shape';
import { getAreaRectangle } from './area';
import { getMapDimension } from './map';
/**
 * Determines whether two row labels will overlap vertically
 * Should only be used when the two row labels are aligned horizontally
 * If the top of one row label is positioned at the bottom of the other, this is not considered overlapping
 */
const rectanglesOverlapVertically = (a, b) => {
    return a.y < b.y ? b.y < a.y + a.height : a.y < b.y + b.height;
};
/**
 * Sorts the row labels by the top position, then scans them, filtering out
 * any row labels that overlap with the previous non overlapping label
 */
const getNonOverlappingRowLabels = (rowLabelProps) => {
    const verticallySortedRowLabelProps = [...rowLabelProps].sort((a, b) => a.rectangle.y - b.rectangle.y);
    const nonOverlappingRowLabelProps = [];
    for (const curr of verticallySortedRowLabelProps) {
        const last = nonOverlappingRowLabelProps.length === 0
            ? undefined
            : nonOverlappingRowLabelProps[nonOverlappingRowLabelProps.length - 1];
        if (last === undefined || !rectanglesOverlapVertically(last.rectangle, curr.rectangle)) {
            nonOverlappingRowLabelProps.push(curr);
        }
    }
    return nonOverlappingRowLabelProps;
};
/**
 * Returns row label props for each row in each area in SVG units.
 */
export function getRowLabelProps(seatLayout, scaleFactor, config, mapRectangle) {
    const seatMargin = config.seats.margin;
    const { size, shape, borderRadius, borderWidth } = config.rowLabels;
    const parsedBorderRadius = shape === SeatPickerShape.Round ? size / 2 : borderRadius;
    const rowLabelProps = [];
    const invertSeatMap = config.screen.position === SeatPickerScreenPosition.Top;
    seatLayout.areas.forEach(area => {
        const areaBoundary = getAreaRectangle(area.boundary, mapRectangle, scaleFactor, config);
        area.rows.forEach(row => {
            if (!row.seats.length)
                return;
            const areaHeight = area.boundary.bottom - area.boundary.top;
            const rowHeightPercentage = areaHeight / area.rowCount;
            const rowHeight = getMapDimension(rowHeightPercentage, scaleFactor) - seatMargin * 2;
            const rowIndex = invertSeatMap ? area.rowCount - row.number : row.number - 1;
            const rowOffsetPercentage = (rowIndex / area.rowCount) * areaHeight;
            const rowAlignmentOffset = (rowHeight - size) / 2;
            const topOffset = getMapDimension(rowOffsetPercentage, scaleFactor) + rowAlignmentOffset + seatMargin;
            rowLabelProps.push({
                key: `${area.number}_${row.number}`,
                rectangle: {
                    y: areaBoundary.y + topOffset,
                    x: config.rowLabels.margin,
                    width: size,
                    height: size
                },
                label: row.label,
                borderRadius: parsedBorderRadius,
                borderWidth: borderWidth
            });
        });
    });
    return getNonOverlappingRowLabels(rowLabelProps);
}
